import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { startRipple } from "./layout/ripple";
import { startTheme } from "./layout/theme";
import "./index.css";

startTheme();
startRipple();

const root = document.getElementById("root");
if (!root) throw new Error("the page has no root element");

// The app kept on the device, for the POS in a hall with no signal. Only in a real build:
// in development the files change on every save and a kept copy would only get in the way.
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").then(async () => {
      // Tell it what this page actually used. The worker cannot know about a font named
      // inside a stylesheet, and an iPad that comes back from a flat battery in a hall
      // with no signal has to find every last piece of the app already here.
      const ready = await navigator.serviceWorker.ready;
      const used = performance
        .getEntriesByType("resource")
        .map((entry) => entry.name)
        .filter((name) => name.startsWith(window.location.origin) && !name.includes("/api/"));
      ready.active?.postMessage({ kind: "keep", urls: [window.location.origin + "/", ...used] });
    });
  });
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
